<template>

  <div >
        
      <v-container>
        <!-- BUTTONS TO TOGGLE BETWEEN ALL MEMORIES AND MY MEMORIES AND MY JOURNALS --->
        <div class="storySelector" >
        <v-row justify="center">
          <v-btn-toggle
          v-model="toggle_exclusive"
          mandatory
          class="mb-5"
        >
          <v-btn v-bind="predefinedBtnProps[$vuetify.breakpoint.name]"  class= "primary m4u_text--text" @click="setFilter('all')">
            All Memories
          </v-btn>
          <v-btn v-bind="predefinedBtnProps[$vuetify.breakpoint.name]"  class= "primary m4u_text--text" @click="setFilter('mine')">
            My Memories
          </v-btn>
          <v-btn v-bind="predefinedBtnProps[$vuetify.breakpoint.name]"  class= "primary m4u_text--text" @click="setFilter('journal')">
            My Journal
          </v-btn>
          <v-btn v-bind="predefinedBtnProps[$vuetify.breakpoint.name]"  class= "primary m4u_text--text" @click="setFilter('drafts')" v-if="drafts">
            My Drafts
          </v-btn>
          <v-btn v-bind="predefinedBtnProps[$vuetify.breakpoint.name]"  class= "primary m4u_text--text" @click="searchOn = !searchOn" icon>
            <v-icon class="m4u_text--text">mdi-magnify</v-icon>
          </v-btn>
        </v-btn-toggle>
            </v-row>
              <v-row justify="center"  v-if="searchOn" class="mt-4">
                <v-card :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'" class="mb-3">
                  <v-col
                    cols="12"
                    sm="11"
                    md="11"
                    lg="11"
                  >
              <v-text-field 
              v-model="searchTerm"
              label="Search" 
              append-icon="mdi-send"
              class="m4u_text--text searchLine"
              @click:append="searchMemories"
              color="m4u_text">
              </v-text-field>
                  </v-col>
              </v-card>
              </v-row>
            <!-- </div> -->
        </div>
            <!-- START STORY CARDS --->
        <v-container>
            <v-container class="messageDiv m4u_text--text mx-auto text-center" v-if="message"
            :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'">
              {{message.MessageText}}</v-container>
        </v-container>
<v-layout justify-center>
          <TodaysQC v-if="user !== undefined || user !== null" :userID="user.UserID" :authCircle="user.UserID"
            class="mb-3 mt-3" />
</v-layout>

          <div v-for="story in stories" :story="story" :key="story.StoryID" >
<v-layout justify-center>
          <StoryCard :story="story" class="storyCardWrapper mb-3 mt-3" :key="resetPage" @refreshList="refreshPage" />
</v-layout>
      </div>


        <!-- </div> -->

        <v-divider></v-divider>
                <!-- empty div for infinite scrolling --->
    <div v-observe-visibility="handleScrolledToBottom"></div>
                <div class="rtl">
        <v-btn
         v-scroll="onScroll"
            v-show="fab"
            fab
            dark
            fixed
            bottom
            right
            color="primary"
            class="m4u_text--text"
            @click="toTop">
            <v-icon>mdi-arrow-up-circle</v-icon>
         </v-btn>
         </div>
    </v-container>


  </div>

</template>
<script>
import StoryCard from "@/components/StoryCard";
import TodaysQC from '@/components/TodaysQC.vue';
import EventService from '@/services/EventService.js'; 

export default {
  name: "StoryList",
  components: {
    StoryCard, 
    TodaysQC,
  },


  data() {
    return {
      story: {},
      message: [],
      resetPage: false,
      stories: [],
      recordStart: 0,
      recordLast: '',
      filter: 'all',
      drafts: false,
      searchOn: false,
      searchTerm: '',
      fab: false,
      toggle_exclusive: undefined,
       predefinedBtnProps: {
          xs: {
            'x-small': true
          },
          sm: {
            'small': true
          },
          md: {
            
          },
          lg: {
            'large': true
          },
          xl: {
            'x-large': true
          }
        }
    };
  },

     computed: {
      user(){
        return this.$store.state.user
      },
      profileSas(){
        return this.$store.state.profileSas
      },
    pageLength(){
        return this.$store.state.pageLength
    },

  stateFilter(){
    return this.$store.state.filter
  },
    
    btnProps()  {
      let props = {}
      switch(this.$vuetify.breakpoint.name) {
        case 'xs':
          props.color = 'primary'
          props['x-small'] = true
          break
        case 'sm':
          props.color = 'primary'
          props['small'] = true
          break  
        case 'lg':
          props.color = 'primary'
          props['large'] = true
          break
          case 'xl':
          props.color = 'primary'
          props['x-large'] = true
          break 
        default: 
          props.color = 'red'
      }
      return props
}
},

    mounted() {

//      console.log('starting mount, this.user.userID is: ', this.user.UserID)
//      console.log('starting this.filter is: ', this.filter, 'stateFilter is: ', this.stateFilter)
      this.recordLast = this.pageLength;
    this.getAllStories(this.user.UserID);
    this.draftCount(this.user.UserID);
    this.getMessage();
    
  },

  methods: {

    async setFilter(filter) {
//      console.log('incoming filter for setFilter is: ', filter)
      this.filter = filter;
      this.$store.dispatch('setFilter', this.filter);
      if(this.filter === 'all') {
        this.getAllStories();
//        console.log('all this.story is : ', this.story)
        return;
      }
      if(this.filter === 'mine') {
        this.getMyStories();
//        console.log('mine this.story is : ', this.story)
        return;
      }
      if(this.filter === 'journal') {
        this.getMyJournal();
//        console.log('journal this.story is : ', this.story)
        return;
      }
      if(this.filter === 'drafts') {
        this.getDrafts();
//        console.log('drafts this.story is : ', this.story)
        return;
      }
    },

    async getMessage() {
      EventService.getMessage()
      .then(
        (message => {
          this.$set(this, "message", message[0]);
        }).bind(this)
      )},

      async refreshPage () {
         this.draftCount(this.user.UserID)
//        console.log('resetting filter to this.stateFilter', this.stateFilter)
        this.setFilter(this.stateFilter);
        this.resetPage = !this.resetPage;
      },

        scrollToAnchorPoint(refName) {
            const el = this.$refs[refName]
            el.scrollIntoView({ behavior: 'smooth' })
        },
        
      onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 10
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    async getMyStories() {
      this.filter = 'mine';
      this.searchOn = false;
        this.searchTerm = '';
        this.stories = [];
        this.recordStart = 0;
        this.recordLast = '';
      await EventService.getMyStories(this.user.UserID, this.recordStart, this.pageLength)
     .then(
        (stories => {
            this.$set(this, "recordLast", stories.output.recordCount)
            this.$set(this, "stories", stories.recordset);
      }).bind(this)
      );
    },

  async  getMoreMyStories() {
    this.filter ='mine'
  if(this.recordStart < this.recordLast || !this.recordLast ) {
    this.recordStart = this.recordStart + this.pageLength
    await EventService.getMyStories(this.user.UserID, this.recordStart, this.pageLength)
      .then(
        (stories => {
            this.stories.push(...stories.recordset)
        }).bind(this)

      );
  }
    },

    async draftCount() {
        this.stories = [];
        this.recordStart = 0;
        this.recordLast = '';
      await EventService.getDrafts(this.user.UserID, this.recordStart, this.pageLength)
     .then(
        (stories => {
//      console.log('draft stories.output.recordCount = ', stories.output.recordCount)
            if (stories.output.recordCount > 0) {
              this.drafts = true
            } else {
              this.drafts = false;
              this.filter = 'all';
              this.$store.dispatch('setFilter', 'all');
              this.setFilter('all')
            }
      }).bind(this)
      );
    },

    async getDrafts() {
      this.filter = 'drafts';
      this.$store.dispatch('setFilter', this.filter);
      this.searchOn = false;
        this.searchTerm = '';
        this.stories = [];
        this.recordStart = 0;
        this.recordLast = '';
      await EventService.getDrafts(this.user.UserID, this.recordStart, this.pageLength)
     .then(
        (stories => {
            this.$set(this, "recordLast", stories.output.recordCount)
            this.$set(this, "stories", stories.recordset);
      }).bind(this)
      );
    },

  async  getMoreDrafts() {
    this.filter ='drafts'
  if(this.recordStart < this.recordLast || !this.recordLast ) {
    this.recordStart = this.recordStart + this.pageLength
    await EventService.getDrafts(this.user.UserID, this.recordStart, this.pageLength)
      .then(
        (stories => {
            this.stories.push(...stories.recordset)
        }).bind(this)

      );
  }
    },
      async getAllStories() {
        this.filter = 'all';
        this.$store.dispatch('setFilter', this.filter);
        this.searchOn = false;
        this.searchTerm = '';
        this.stories = [];
        this.recordStart = 0;
        this.recordLast = '';
      await EventService.getAllStories(this.user.UserID, this.recordStart, this.pageLength)
     .then(
        (stories => {
            this.$set(this, "recordLast", stories.output.recordCount)
            this.$set(this, "stories", stories.recordset);
}).bind(this)

      );
    },

  async  getMoreAllStories() {
    this.filter = 'all';
  if(this.recordStart < this.recordLast || !this.recordLast ) {
    this.recordStart = this.recordStart + this.pageLength

    await EventService.getAllStories(this.user.UserID, this.recordStart, this.pageLength)
      .then(
        (stories => {
            this.stories.push(...stories.recordset)
        }).bind(this)

      );
  }
    },

    async searchMemories() {
      this.filter = 'search'
      this.$store.dispatch('setFilter', this.filter);
        this.searchOn = false;
        this.stories = [];
        this.recordStart = 0;
        this.recordLast = '';
      await EventService.searchMemories(this.user.UserID, this.recordStart, this.pageLength, this.searchTerm)
     .then(
        (stories => {
            this.$set(this, "recordLast", stories.output.recordCount)
            this.$set(this, "stories", stories.recordset);
            this.searchTerm = '';
      }).bind(this)
      );
    },

  async  searchMoreMemories() {
    this.filter ='search'
  if(this.recordStart < this.recordLast || !this.recordLast ) {
    this.recordStart = this.recordStart + this.pageLength
    await EventService.searchMemories(this.user.UserID, this.recordStart, this.pageLength)
      .then(
        (stories => {
            this.stories.push(...stories.recordset)
        }).bind(this)

      );
  }
    },

    async getMyJournal() {
      this.filter = 'journal';
      this.$store.dispatch('setFilter', this.filter);
      this.searchOn = false;
        this.searchTerm = '';
        this.stories = [];
        this.recordStart = 0;
        this.recordLast = '';
      await EventService.getMyJournal(this.user.UserID, this.recordStart, this.pageLength)
     .then(
        (stories => {
            this.$set(this, "recordLast", stories.output.recordCount)
            this.$set(this, "stories", stories.recordset);

      }).bind(this)
      );
    },

  async  getMoreJournal() {
    this.filter ='journal'
  if(this.recordStart < this.recordLast || !this.recordLast ) {
    this.recordStart = this.recordStart + this.pageLength
    await EventService.getMyJournal(this.user.UserID, this.recordStart, this.pageLength)
      .then(
        (stories => {
            this.stories.push(...stories.recordset)
        }).bind(this)
      );
  }
    },

    openMemory(memory) {
      this.$store.dispatch('setStory', memory);
      this.$router.push({ name: 'memoryreader', params: { incomingStoryId: memory.StoryID } })
    },

    handleScrolledToBottom(isVisible){

        if(!isVisible){
            return
        } else 
        {
          if(this.filter === 'all') {
            this.getMoreAllStories() }
          if(this.filter === 'mine') {
              this.getMoreMyStories() }
          if(this.filter === 'search') {
              this.searchMoreMemories() }
          if(this.filter === 'journal') {
              this.getMoreJournal() }
          if(this.filter === 'drafts') {
              this.getMoreDrafts() }
            }
    },

  }
};
</script>
<style lang="scss" scoped>

.messageDiv {
  justify-content: "center";
  background-color: "#FFFDE7";
  font-size: 2em;
}

.containerGrid {
  margin-top: 2em;
  display:grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-rows: 380px;
  grid-gap: .5em;
}

.rtl {
  direction: rtl;
}

.searchLine {

  justify-content: center;
}

  .storySelector {
    justify-content: center;
    margin-bottom: 5px;
    margin-top: 5px;
  }

  .storyCardWrapper {
    max-height: 85%;
  }


</style>